// Ordine del prospetto inventario di Ideariso (PRODOTTO;SCADENZA;U.M.;QUANTITA;LOTTO),
// poi le colonne aggiuntive: togliendole dalle impostazioni si ottiene lo stesso file.
export const INVENTORY_COLUMNS = [
  ['product_name', 'Prodotto'], ['expiration_date', 'Scadenza'], ['unit', 'UM'],
  ['quantity', 'Quantità'], ['lot_number', 'Lotto'],
  ['sku', 'Codice'], ['warehouse', 'Magazzino'], ['status', 'Stato'],
] as const;
export const INVENTORY_STATUS_LABELS: Record<string, string> = {
  available: 'Disponibile', exhausted: 'Esaurito', reserved: 'Riservato', in_production: 'In produzione',
  with_contractor: 'Presso terzista', disposed: 'Smaltito', without_lot: 'Senza lotto',
};
/** Valore leggibile di una cella: data gg/mm/aaaa, quantità con la virgola, stato in italiano. */
export function inventoryCellText(column: InventoryColumn, value: unknown): string {
  if (value == null || value === '') return '';
  if (column === 'expiration_date') {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : String(value);
  }
  if (column === 'quantity') return Number(value).toLocaleString('it-IT', { maximumFractionDigits: 3, useGrouping: false });
  if (column === 'status') return INVENTORY_STATUS_LABELS[String(value)] || String(value);
  return String(value);
}
export type InventoryColumn = typeof INVENTORY_COLUMNS[number][0];
export interface WarehouseReportingSettings {
  inventory_view: 'movements' | 'lots';
  include_zero: boolean; include_negative: boolean; include_unlotted: boolean;
  category_filter: boolean; columns: InventoryColumn[];
  archive_files: boolean; archive_camera: boolean; archive_drive: boolean;
}
export function normalizeWarehouseReporting(raw: unknown): WarehouseReportingSettings {
  const p = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
  const columns = INVENTORY_COLUMNS.map(([key]) => key).filter(key => Array.isArray(p.columns) && p.columns.includes(key));
  return {
    inventory_view: p.inventory_view === 'lots' ? 'lots' : 'movements',
    include_zero: p.include_zero !== false, include_negative: p.include_negative !== false,
    include_unlotted: p.include_unlotted !== false, category_filter: p.category_filter !== false,
    columns: columns.length ? columns : INVENTORY_COLUMNS.map(([key]) => key),
    archive_files: p.archive_files !== false, archive_camera: p.archive_camera === true, archive_drive: p.archive_drive === true,
  };
}
export function inventoryCsv(rows: Record<string, unknown>[], columns: InventoryColumn[]) {
  // La protezione dalle formule vale per i testi: una quantità negativa (-29) resta un numero.
  const cell = (text: string, guard = true) => {
    if (guard && /^[=+\-@\t\r]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  const headers = columns.map(c => INVENTORY_COLUMNS.find(([key]) => key === c)![1]);
  return '\uFEFF' + [headers.map(h => cell(h)).join(';'), ...rows.map(row => columns.map(c => cell(inventoryCellText(c, row[c]), c !== 'quantity')).join(';'))].join('\r\n');
}
